import { useEffect } from 'react';

/**
 * Warn before losing a half-filled form.
 *
 * Covers reload, tab close and back-out-of-the-app via the browser's own
 * `beforeunload` prompt. It does NOT intercept in-app navigation: `useBlocker`
 * needs a data router (`createBrowserRouter`), and this app mounts a plain
 * `<BrowserRouter>`. Migrating the router for this alone is more risk than the
 * problem is worth, so in-app exits are guarded at the Cancel button instead.
 */
export function useUnsavedChanges(dirty: boolean) {
  useEffect(() => {
    if (!dirty) return;

    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      // Browsers ignore custom text now, but a non-empty returnValue is still
      // what triggers the prompt in some of them.
      e.returnValue = '';
    };

    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [dirty]);
}
